<!-- TODO: example as an example and only used in EducationProductionDetail. Please rename or refactor if needed -->
<template>
  <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-12 gap-x-8 sm:gap-x-3 md:gap-x-8 xl:gap-x-16">
    <time class="col-span-1 lg:col-span-3 flex flex-col text-sm lg:text-base leading-tight">
      <span class="font-semibold">{{ d_(eventDate, 'long-date') }}</span>
      <span>{{ d_(eventDate, 'short-time') }}</span>
    </time>
    <div v-if="isBookable" class="col-span-1 lg:col-span-3 flex flex-col text-sm lg:text-base leading-tight">
      <span class="mb-3">{{ tc_('remaining-text', remaining) }}</span>
    </div>
    <div v-else class="col-span-1 lg:col-span-3 flex flex-col text-sm lg:text-base leading-tight">
      <span v-if="bookableFromDate && new Date(bookableFromDate) > new Date()" class="mb-3">Kaartverkoop start op {{ d_(bookableFromDate, 'long-date') }}</span>
      <span v-else class="mb-3">
        {{ t_('unavailable') }}
      </span>
    </div>
    <div v-if="url && isBookable" class="col-span-2 sm:col-span-1 lg:col-span-6 flex items-start sm:justify-end pt-6 sm:pt-0">
      <MoleculeButton :url="url" target="_self" size="small" class="lg:hidden shrink-0" background-color="bg-black hover:bg-app-secondary-7-violet--purple-heart">
        {{ t_('modal-book-visit-button') }}
      </MoleculeButton>
      <MoleculeButton :url="url" target="_self" class="hidden lg:flex shrink-0" background-color="bg-black hover:bg-app-secondary-7-violet--purple-heart">
        {{ t_('modal-book-visit-button') }}
      </MoleculeButton>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  eventDate: { type: [String, Date], required: false, default: undefined },
  isEducationCustomer: { type: Boolean, required: false, default: false },
  remaining: { type: Number, required: false, default: 0 },
  educationTixSale: { type: Object as PropType<Record<string, any>>, required: false, default: () => ({}) },
  url: { type: String, required: false, default: undefined },
  bookableFromDate: { type: [String, Date], required: false, default: undefined },
})

const { isBookable } = props.educationTixSale

const { t_, tc_, d_ } = setupTranslationPrefixer('Education', 'InfoRow')
</script>
